import { render } from "./VirtualRedTagTrailerGraphic.vue?vue&type=template&id=4b342b78&scoped=true&ts=true"
import script from "./VirtualRedTagTrailerGraphic.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagTrailerGraphic.vue?vue&type=script&lang=ts"

import "./VirtualRedTagTrailerGraphic.vue?vue&type=style&index=0&id=4b342b78&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b342b78"]])

export default __exports__